import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { HeimtierBeleg } from '../../heimtier-beleg';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'kiene-besuchs-detail-informationen',
    templateUrl: './besuchs-detail-informationen.component.html',
    styleUrls: ['./besuchs-detail-informationen.component.scss'],
})
export class BesuchsDetailInformationenComponent implements OnInit, OnChanges {
    @Input() heimtierBeleg: HeimtierBeleg;

    kunde: Client;

    constructor(
        private readonly api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit(): void {}

    ngOnChanges() {
        this.ladeKunde();
    }

    private ladeKunde() {
        if (this.heimtierBeleg) {
            const params = new HttpParams().set('kunde_id', this.heimtierBeleg.kunde_id);
            this.api.get(this.apiBaseUrl + 'heimtier_kunde/read_one.php', params).subscribe({
                next: response => {
                    this.kunde = response;
                },
            });
        }
    }
}
